// * Import images
import powerBiLogo from "../../assets/images/power-bi-logo.svg";

const backendApi = "/api";
const sherlockAssist = "https://sherlock.reckitt.com";

export const API_ENDPOINTS = {
  signinUrl: `${backendApi}/login`,
  userinfoUrl: `${backendApi}/userinfo`,
  signupTemplateUrl: `${backendApi}/signup-data`,
  reportsUrl: `${backendApi}/applications`,
  dataGovernance: `${backendApi}/dataGovernance`,
  updateDataSource: `${backendApi}/dataSource`,
  templateUrl: `${backendApi}/apptemplate`,
  goldTableReportsUrl: `${backendApi}/goldtablereports`,
  datasetRegisterUrl: `${backendApi}/dataset`,
  reportRegisterUrl: `${backendApi}/report`,
  applicationUrl: `${backendApi}/standaloneApp`,
  myAppsUrl: `${backendApi}/homeapps`,
  favouritesUrl: `${backendApi}/favourites`,
  applicationDetailsUrl: `${backendApi}/applicationDetails`,
  endorsementUrl: `${backendApi}/addEndorse`,
  applicationSuggestionsUrl: `${backendApi}/getapplicationsuggestions`,
  dataLineageUrl: `${backendApi}/datalineage`,
  reportLineageUrl: `${backendApi}/reportlineage`,
  logout: `${backendApi}/logout`,
  searchUrl: `${backendApi}/search`,
  getApplicationdetailsUrl: `${backendApi}/applicationeditdetails`,
  faqUrl: `${backendApi}/faqs`,
  resourcesUrl: `${backendApi}/resources`,
  requestAccessUrl: `${backendApi}/requestAccess`,
  imageuploadv2Url: `${backendApi}/imageuploadv2`,
  registerGroupAppUrl: `${backendApi}/groupreport`,
  subApplicationEditDetailsUrl: `${backendApi}/subapplicationeditdetails`,
  accessManagementUrl: `${backendApi}/accessmanagement`,
  pendingRequestsUrl: `${backendApi}/pendingrequests`,
  groupPendingRequestsUrl: `${backendApi}/groupPendingRequests`,
  oktaSearchUsersUrl: `${backendApi}/okta/userSearch`,
  oktaSearchGroupsUrl: `${backendApi}/azure/groupSearch`,
  publishUrl: `${backendApi}/publishStatus`,
  appApprovalUrl: `${backendApi}/approvalStatus`,
  accessUrl: `${backendApi}/accessStatus`,
  confirmAccessStatusUrl: `${backendApi}/confirmaccessstatus`,
  imageUploadV2Url: `${backendApi}/imageuploadv2`,
  dataModelRequestAccessUrl: `${backendApi}/dataModelRequestAccess`,
  appUserListUrl: `${backendApi}/getAppUserList`,
  usageMetricsUrl: `${backendApi}/usageMetrics`,
  accessHistoryUrl: `${backendApi}/accessHistory`,
  sourceTablesUrl: `${backendApi}/sourceTables`,
  azureADGroupUrl: `${backendApi}/azureADGroup`,
  getAllCommentsUrl: `${backendApi}/allcomments`,
  commentsUrl: `${backendApi}/comments`,
  commentUrl: `${backendApi}/comment/like`,
  recommendedAppsUrl: `${backendApi}/recommendedapps`,
  irrelevantAppsUrl: `${backendApi}/irrelevantapps`,
  reRequestUrl: `${backendApi}/rerequestApps`,
  approvalsUrl: `${backendApi}/adminapps`,
  approvalsDetailsUrl: `${backendApi}/applicationeditdetailstoadmins`,
  approvalsActionsUrl: `${backendApi}/validateApps`,
  sampleDataUrl: `${backendApi}/sampleData`,
  getSigviewViewName: `${backendApi}/get_sigview_view_name`,
  allTicketsUrl: `${backendApi}/jira/search`,
  ticketTemplateUrl: `${backendApi}/ticketTemplate`,
  getTicketDetailsUrl: `${backendApi}/jira/issue`,
  feedbackUrl: `${backendApi}/feedback`,
  feedbackMailUrl: `${backendApi}/feedbackmail`,
  incidentMailUrl: `${backendApi}/incidentmail`,
  featureMailUrl: `${backendApi}/featuremail`,
  getAllUsersUrl: `${backendApi}/okta/orgUserSearch`,
  attachmentsUrl: `${backendApi}/jira/attachment`,
  allAppsUrl: `${backendApi}/allapps`,
  ticketCommentUrl: `${backendApi}/jira/comment`,
  applicationDetailsAccessUrl: `${backendApi}/userAccessCount`,
  brandMaintainenceUrl: `${backendApi}/brand`,
  brandMaintenanceStatusUrl: `${backendApi}/brand/status`,
  getpowerBiAccessUrl: `${backendApi}/get_powerbi_access`,
  powerBiLogin: `${backendApi}/powerbi_login`,
  powerBiRefreshUrl: `${backendApi}/get_refresh_token`,
  searchConversationsUrl: `${backendApi}/searchConversations`,
  getSpecificConversationUrl: `${backendApi}/getSpecificConversation`,
  updateConversationUrl: `${backendApi}/updateConversation`,
  socketConnectionForSmartSearch: `${backendApi}/chatbotspace`,
  updateQueryDetailUrl: `${backendApi}/updateQueryDetail`,
  getKPIInitialDataUrl: `${backendApi}/getDataProductList`,
  getEventValueUrl: `${backendApi}/getEventValue`,
  // Column Definition
  downloadFileUrl: `${backendApi}/downloadColumnDefinition`,
  ColumnDefinitionUrl: `${backendApi}/columnDefinition`,
  getReusabilityEventValueUrl: `${backendApi}/kpiReusability`,
  getTopUsersUrl: `${backendApi}/getTopUsersData`,
  getAppRankingUrl: `${backendApi}/getAppRanking`,
  dataCatalogTemplateUrl: `${backendApi}/dataCatalogTemplate`,
  specificDataCatalogUrl: `${backendApi}/dataCatalog`,
  KPIDataUsageReportUrl: `${backendApi}/KPIDataUsageReport`,
  advanceSearchUrl: `${backendApi}/advanceSearch`,
  dataProductLandingUrl: `${backendApi}/dataProducts`,

  // Rapid URLs
  billingDashboardUrl: `${backendApi}/rapid/auth/dashboard`,
  monitoringDashboardUrl: `${backendApi}/rapid/auth/dashboard/mjn-monitoring`,
  opspendingpageUrl: `${backendApi}/rapid/devops/request`,
  opsAccessUrl: `${backendApi}/rapid/devops/access`,
  opsEditedAccessUrl: `${backendApi}/rapid/devops/access/history`,
  opsSubmitRolesUrl: `${backendApi}/rapid/devops/submit-roles`,
  opsEditSubmitRolesUrl: `${backendApi}/rapid/devops/submit-edited`,
  opsEditedResourcesUrl: `${backendApi}/rapid/models/edited-request`,
  getUseCasesUrl: `${backendApi}/rapid/models/usecases`,
  searchModelsUrl: `${backendApi}/rapid/models/search`,
  rotateApiKeyUrl: `${backendApi}/rapid/rotate-key`,
  generateApiKeyUrl: `${backendApi}/rapid/generate-key`,

  // Rapid User URLs
  rapidUserLandingPageUrl: `${backendApi}/rapid/requests`,
  rapidRegisterTemplateUrl: `${backendApi}/rapid/template`,
  rapidSubmitApplicationUrl: `${backendApi}/rapid/request/submit`,
  rapidSubmiEditApplicationUrl: `${backendApi}/rapid/request/re-submit`,
  rapidEditApplicationUrl: `${backendApi}/rapid/request`,
  searchoktaAllUsers: `${backendApi}/rapid/search/oktaAllUsers`,
  checkAppURLUnique: `${backendApi}/rapid/validate_app_name`,
  rapidUserSharedAppsUrl: `${backendApi}/rapid/technical_owner/request`,
  rapidTrackStatusUrl: `${backendApi}/rapid/requests/status`,

  // Rapid Admin URLs
  rapidAdminLandingPageUrl: `${backendApi}/rapid/admin/requests`,
  rapidApproveRejectApplicationUrl: `${backendApi}/rapid/admin/request`,
  rapidSaveAsDraftUrl: `${backendApi}/rapid/request/saveAsDraft`,
  getReportListUrl: `${backendApi}/registeredReports/all`,
  getStandaloneAppListUrl: `${backendApi}/registeredStandaloneApp/all`,
  getTagsUrl: `${backendApi}/tags/all`,
  getRegisteredDatasetUrl: `${backendApi}/registeredDataAssets/all`,
  getAllTablesUrl: `${backendApi}/tables/all`,
  getAllWorkspacesUrl: `${backendApi}/workspace/all`,
  getSigviewTableColumnDef: `${backendApi}/metadata/columnDefinitions`,
  sigviewTableColumnDefDownload: `${backendApi}/metadata/downloadColumnDefinitions`,
  sigviewAutomationMetaJsonAPI: `${backendApi}/sigview/json`,
  sigviewAutomationLandingPageAPI: `${backendApi}/sigview/landingpage`,
  sigviewAutomationSubmit: `${backendApi}/metadata/submit`,
  sherlockAssistNewSession: `${sherlockAssist}/chat/sessions`,
  sherlockAssistSendQuery: `${sherlockAssist}/chat/sessions/`,
  sherlockAssistJobStatus: `${sherlockAssist}/chat/status/`,
  sherlockAssistSessionMessage: `${sherlockAssist}/chat/sessions/`,
  sherlockAssistAllSessions: `${sherlockAssist}/chat/sessions`,
  sherlockAssistReact: `${sherlockAssist}/chat/messages/`,
  sherlockAssistSearchUrl: `${sherlockAssist}/chat/search/messages`,
  sherlockAssistDatabricksHealthCheck: `${sherlockAssist}/health/ready`,
  sherlockAssistAddFilter: `${sherlockAssist}/filters/sessions/`,
  sherlockAssistStateDepenedentFilter: `${sherlockAssist}/filters/options/dependent`,
  sherlockAssistSessionFilters: `${sherlockAssist}/filters/sessions/`,
  sherlockAssistSendMessage: `${sherlockAssist}/chat/message`,
  sherlockAssistSendContinueMessage: `${sherlockAssist}/chat/continue`,
  getSpotlightDataUrl: `${backendApi}/getSpotlightData`,
  getDataProductGroupByUrl: `${backendApi}/getDataProductGroupBy`,
  dataCatalogUrl: `${backendApi}/metadata/submit`,
  getReportDataUrl: `${backendApi}/getApplicationGroupBy`,
  getDataProductAppDataUrl: `${backendApi}/v2/fetchApplications`,
  getDataCatalogDataUrl: `${backendApi}/getCatalogDetails`,
  submitReviewURL: `${backendApi}/add_user_rating`,
  dataProductUrl: `${backendApi}/getDataProductGroupBy`,
  dataProductDetailUrl: `${backendApi}/getDataProductDetail`,
  dataCoverageUrl: `${backendApi}/dataCoverage`,
  newLineageUrl: `${backendApi}/lineage/v2`,
  // Brain 2.0 urls
  brainDashboardUrl: `${backendApi}/brain/admin/dashboard`,
  fetchBrainSubmissionsDataUrl: `${backendApi}/brain/submissions`,
  fetchBrainApprovalDataUrl: `${backendApi}/brain/approvals`,
  fetchBrainAccessManagementUrl: `${backendApi}/brain/access-management`,
  updateBrainAccessManagementUrl: `${backendApi}/brain/access-management/v2`,
  reviewDataUrl: `${backendApi}/brain/data/review-table`,
  submitBrainReviewUrl: `${backendApi}/brain/submit`,
  validateEmail: `${backendApi}/brain/validate/email`,
  functionAccessUrl: `${backendApi}/brain/function`,
  reviewColumnsUrl: `${backendApi}/brain/review-columns`,
  assignApproverUrl: `${backendApi}/brain/approvals/assign/`,
  ssotUrl: `${backendApi}/brain/ssot`,
  brainTeamUrl: `${backendApi}/brain/team`,
  brainusers: `${backendApi}/brain/users`,
  downloadReviewDataUrl: `${backendApi}/brain/data/download-review-table`,
  competitorDataUrl: `${backendApi}/brain/data/par-table`,
  brainInputValidationUrl: `${backendApi}/brain/data/validate`,
  brainDashboardSubmissionUrl: `${backendApi}/brain/upc-overview`,

  // Harbor Urls
  fetchHarborAccessManagementUrl: `${backendApi}/harbor/access/users/search`,
  validateHarborEmail: `${backendApi}/harbor/access/users/validate-email`,
  fetchHarborSources: `${backendApi}/harbor/access/country-sources`,
  updateHarborUsers: `${backendApi}/harbor/access/users`,
  fetchReviewColumns: `${backendApi}/harbor/review-columns`,
  harborReviewDataUrl: `${backendApi}/harbor/data/review-table`,
  downloadHarborReviewDataUrl: `${backendApi}/harbor/data/download-review-table`,
  submitHarborReviewUrl: `${backendApi}/harbor/submit`,
  fetchHarborSubmissionsDataUrl: `${backendApi}/harbor/submissions`,
  fetchHarborApprovalDataUrl: `${backendApi}/harbor/approvals`,
  assignHrborApproverUrl: `${backendApi}/harbor/approvals/assign/`,
  harborSsotUrl: `${backendApi}/harbor/ssot`,
  knowledgeHubUrl: `${backendApi}/harbor/knowledge-hub/table`,
  harborUploadExcel: `${backendApi}/harbor/submit/import`,
  knowledgeHubTableList: `${backendApi}/harbor/knowledge-hub/tables`,
  knowledgeHubHistoryUrl: `${backendApi}/harbor/knowledge-hub/table/history`,
};

export const MESSAGES = {
  FAV_REMOVED: "Removed from favourites successfully!",
  FAV_REMOVE_FAIL: "Remove from favorites failed. Please try again.",
  FAV_ADDED: "Favourite added successfully!",
  FAV_ADD_FAIL: "Adding to favorites failed. Please try again.",
  ART: "DART",
  ART_FULL: "Analytics with Reliability & Trust",
  NAM: "DART",
  ENDORSEMENT_CHANGE_FAIL:
    "Endorsement status could not be changed currently! Please try again!",
  ONE_STOP: "One stop for all data and reports, anytime, anywhere",
  ADMIN_SUBMESSAGE: "All application accesses here",
  REQUEST_ACCESS_FAIL: "Access could not be requested! Please try again later!",
  PUBLISH_STATUS_FAIL:
    "Publish Status could not be changed! Please try again later!",
  PUBLISH_STATUS_PASS: "Publish Status updated successfully!",
  REREQUEST_STATUS_FAIL:
    "Application could not be submitted for re-approval. Please try again later!",
  REREQUEST_STATUS_PASS: "Application submitted for re-approval successfully",
  APP_STATUS_PASS: "Application status updated successfully!",
  APP_STATUS_FAIL:
    "Application Status could not be changed! Please try again later!",
  GROUP_NAME_COPIED: "Group name copied to clipboard!",
  LINK_COPIED: "Link copied to clipboard!",
  USER_APPROVED: "User has been added to the report successfully!",
  USER_APPROVE_FAIL:
    "User could not be added to the report! Please try again later!",
  USER_REJECTED: "Access to the report rejected successfully!",
  USER_REJECT_FAIL: "Rejection failed, Please try again later!",
  SAVE_REPORT: "Report acccess updated successfully!",
  SAVE_REPORT_FAIL: "Report could not be updated, Please try again later!",
  NO_FAQS: "FAQs could not be loaded! Please try again later!",
  USER_APPROVED_DATASET: "User has been added to the data Asset successfully!",
  USER_APPROVE_FAIL_DATASET:
    "User could not be added to the data Asset! Please try again later!",
  USER_REJECTED_DATASET: "Access to the data Asset rejected successfully!",
  SAVE_REPORT_DATASET: "Data Assset acccess updated successfully!",
  SAVE_REPORT_FAIL_DATASET:
    "Data Asset could not be updated, Please try again later!",
  GO_TO_DETAILS: "Go to details",
  REQUEST_RAISED: "Request Raised",
  UNAUTHORIZED: "You don't have permission to access this resource",
  SOMETHING_WENT_WRONG: "Something went wrong! Please try again later!",
  FINAL_SCREEN_MESSAGE: "You are all set!",
  FINAL_SCREEN_BUTTON_TEXT: "Go to Explore",
  NO_RESULT_FOUND: "No Result Found",
  ERROR_BASIC: "ERROR IN FETCHING DATA",
  URL_MISMATCH: "Incorrect URL format.",
  confirm_DELETE: "Are you sure you want to delete?",
  APPROVED: "Approved successfully!",
  REJECTED: "Rejected successfully!",
  ALL_APPROVALS: "No Applications found! Please check again later!",
  PENDING_APPROVALS: "No Pending Approvals found! Please check again later",
  SAMPLE_DATA_ERROR: "Unable to load Sample data! Please try again Later!",
  NO_SAMPLE_DATA: "No Sample Data found for this data Asset!",
  MAX_EMAIL_IN_HELP: "You can't select more than 5 emails.",
  FILE_SIZE_LIMIT_MESSAGE: "Please upload file less than 1MB.",
  ATTACHEMENTS_LIMIT: "You can't select more than 5 attachments.",
  PROFILE_HEADER:
    "Manage your profile and preferences to make us work better for you.",
  BRAND_MAINTENANCE: "Add/Retire Brands from single interface.",
  DATA_GOVERNANCE:
    "Find all Data products along with thier Reports and Sources",
  NO_RESOURCES: "No Resources found! Please check again later!",
  CONVERSATION_CHANGE_FAIL:
    "Like/Dislike status could not be changed currently! Please try again!",
  KPI_DASHBOARD: "Uncover essential insights through this dashboard.",

  COLUMNDEF_UPDATED: "Column Definition updated successfully!",
  COLUMNDEF_ERROR: "Column Definition could not be updated! Please try again!",
  COLUMNDEF_DATA_ERROR:
    "Column Definition data could not be loaded! Please try again!",
  DOWNLOAD_SUCCESS: "File downloaded successfully!",
  DOWNLOAD_FAIL: "File could not be downloaded! Please try again!",
  SCREENSHORT_FAIL: "Failed to take screenshot!",
  RAPID: "RAPID - Resource Allocation Platform for Initiative Development",
  GROUP_REPORT_DESCRIPTION:
    "Power-bi Reports or dashboards, that you would want to group together to give your users a holistic view to your data story.",
  REPORT_DESCRIPTION:
    "A single report that provides information or analysis on a specific topic, issue, or set of data, typically created for internal or external stakeholders to inform decision-making or communicate findings.",
  SIGVIEW_SUBMIT_SUCCESS: "Submitted Successfully",
  SIGVIEW_SUBMIT_FAILURE: "Submission Failed",
};

// Status
const INITIAL = "initial";
const LOADING = "loading";
const SUCCESS = "success";
const FAILURE = "failure";
const ERROR = "error";
const SIGN_OUT = "signOut";
const REPORT = "report";
const GROUP_REPORT = "group_report";
const DATASET = "dataset";
const STANDALONE_APP = "standalone_app";
const ALL_APPS = "allApps";
const SEARCH_LIMIT = 3;
const DESC_LIMIT = 2000;
const DESC_ROWS = 12;
const DEFAULT_OFFSET = 0;
const DEFAULT_LIMIT = 5;
const COMMENTS_INTERVAL = 60000;
const COMMENT_TEXT = "comment";
const REPLY_TEXT = "reply";
const YES_FLAG = "yes";
const MAX_TABLE_VALUE = 2;
const APP_NAME_LIMIT = 100;
const REPORT_OPTION = ["group_report", "report"];
const TABLE_VIEW = "table-view";
const CARD_VIEW = "card-view";
const PROPERTIES_TI_INCLUDE = [
  "product_streams",
  "product_lines",
  "regions",
  "data_sources",
];
const DISCOVER_TAB = ["Curated Boards", "Data Products", "Data Catalog"];
const SAVED_TAB = ["Curated Boards", "Reports", "Data Assets", "Applications"];
const TEXT_LIMIT_SMALL = 15;
const TEXT_LIMIT_XSMALL = 15;
const BRAIN_PAGE_SIZE = 20;

const RAPID_STATUS = {
  PROCESS_INITIATED: "PROCESS_INITIATED",
  TECHNICAL_OWNER_RESPONSE_PENDING: "TECH_OWNER_RESPONSE_PENDING",
  PENDING_INFORMATION: "APPROVAL_PENDING",
  INFRA_IN_PROGRESS: "INFRA_IN_PROGRESS",
  REJECTED: "APPROVAL_REJECTED",
  FINISHED: "FINISHED",
  ERROR: "ERROR_WHILE_DEPLOYMENT",
  APPROVED: "Approved", //// To be discussed
  // ACCESS_PENDING: "ACCESS_PENDING",
  // APPROVED_PENDING_DEVOPS: "APPROVED_PENDING_DEVOPS",
};

const SIGVIEW_AUTOMATE_STATUS = {
  TO_BE_CREATED: "To be Created",
  IN_PROGRESS: "In Progress",
  FAILED: "Failed",
  COMPLETED: "Completed",
};

const PERSONA_PAGE = {
  DISCOVER: "Discover",
  REPORT_DETAILS: "reportDetails",
  GROUP_REPORT_DETAILS: "groupReportDetails",
  ADMIN_DASHBOARD: "admin",
  ALL_PAGE: "all",
  SIDE_NAV: "sideNav",
  MY_APPS: "myApps",
  HELP_CENTER: "help",
  DATASET_DETAILS: "datasetDetails",
};

const SHERLOCK_FILTERS = {
  STATE: "State",
  CITY: "City",
  RETAILER: "Retailer",
  STORE: "Store",
  BRAND: "Brand",
  SKU: "SKU",
};

const VISIBLE_COLUMN = "visibleColumns";
const VISIBLE_SKU_COLUMN = "visibleSkuColumns";
const COLUMN_ORDER = "columnOrder";
const COMPETITOR_VISIBLE_COLUMN = "competitorVisibleColumns";
const COMPETITOR_COLUMN_ORDER = "competitorColumnOrder";
const FREEZED_COLUMNS = "freezedColumns";
const TAG_COLUMNS = ["functional_nutrients", "sku", "retailerkey"];
const KEY_REFERENCE_COLUMNS = ["upc", "description"];
const FREEZABLE_COLUMNS = ["upc", "description"];
const SMALL_WIDTH_COLUMNS = [
  "flavour",
  "pack_size",
  "packs_per_unit",
  "total_unit_size",
  "organic_fl",
  "non_gmo_fl",
  "unit_measure",
];
const INT_COLUMNS = ["packs_per_unit"];
const FLOAT_COLUMNS = ["pack_size", "total_unit_size"];

// Habor Constants Start
const HARBOR_VISIBLE_COLUMN = "harborVisibleColumns";
const HARBOR_COLUMN_ORDER = "harborColumnOrder";
const HARBOR_FREEZED_COLUMNS = "harborFreezedColumns";
const HARBOR_FREEZABLE_COLUMNS = [
  "country_source_upc",
  "source_upc",
  "country",
  "source",
  "country_source_combo_upc",
  "source_desc",
];
const HARBOR_COLUMNS_WIDTHS = {
  country_source_upc: 150,
  source_upc: 150,
  country: 150,
  source: 150,
  country_source_combo_upc: 220,
};
const HARBOR_PAGE_SIZE = 20;
const HARBOR_EXCLUDED_COLUMNS = [
  "pred_glo_eq_per_pack",
  "pred_glo_eq_per_unit",
  "pred_glo_include",
  "pred_glo_category",
  "pred_glo_segment",
  "pred_glo_type",
  "pred_glo_manufacturer_group",
];
// Habor Constants End

const APP_CONSTANTS = {
  INITIAL,
  LOADING,
  SUCCESS,
  FAILURE,
  ERROR,
  SIGN_OUT,
  REPORT,
  GROUP_REPORT,
  DATASET,
  STANDALONE_APP,
  ALL_APPS,
  SEARCH_LIMIT,
  DESC_LIMIT,
  REPORT_OPTION,
  DESC_ROWS,
  DEFAULT_OFFSET,
  DEFAULT_LIMIT,
  COMMENTS_INTERVAL,
  COMMENT_TEXT,
  REPLY_TEXT,
  YES_FLAG,
  MAX_TABLE_VALUE,
  APP_NAME_LIMIT,
  PROPERTIES_TI_INCLUDE,
  TABLE_VIEW,
  CARD_VIEW,
  RAPID_STATUS,
  PERSONA_PAGE,
  DISCOVER_TAB,
  SAVED_TAB,
  MEDIUM_CARD_WIDTH: 350,
  MEDIUM_CARD_HEIGHT: 200,
  SMALL_CARD_WIDTH: 250,
  SMALL_CARD_HEIGHT: 158,
  SIGVIEW_AUTOMATE_STATUS,
  SHERLOCK_FILTERS,
  TEXT_LIMIT_SMALL,
  TEXT_LIMIT_XSMALL,
  BRAIN_PAGE_SIZE,
  VISIBLE_COLUMN,
  VISIBLE_SKU_COLUMN,
  COMPETITOR_VISIBLE_COLUMN,
  COLUMN_ORDER,
  COMPETITOR_COLUMN_ORDER,
  TAG_COLUMNS,
  KEY_REFERENCE_COLUMNS,
  FREEZABLE_COLUMNS,
  SMALL_WIDTH_COLUMNS,
  INT_COLUMNS,
  FLOAT_COLUMNS,
  FREEZED_COLUMNS,
  HARBOR_VISIBLE_COLUMN,
  HARBOR_COLUMN_ORDER,
  HARBOR_FREEZED_COLUMNS,
  HARBOR_FREEZABLE_COLUMNS,
  HARBOR_COLUMNS_WIDTHS,
  HARBOR_PAGE_SIZE,
  HARBOR_EXCLUDED_COLUMNS,
};
export const APP_TYPES = {
  report: "Report",
  dataset: "Dataset",
  standalone_app: "Standalone Application",
};

export const BI_PLATFORMS = {
  POWERBI: { value: "powerbi", src: powerBiLogo },
};

export const ACCESS_TYPES = {
  PRIVATE: { value: "private", iconName: "lock" },
  PUBLIC: { value: "public", iconName: "public" },
};

export const URL_REGEX = {
  url: /[-a-zA-Z0-9@:%._+~#=]{1,256}.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi,
  powerbi:
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%.\+#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%\+.#?&//=]*)/g,
};

export const RESOURCE_TYPE = {
  description: "Resource Type",
  names: [
    {
      disabled: null,
      id: 1,
      name: "Video",
    },
    {
      disabled: null,
      id: 2,
      name: "Document",
    },
    {
      disabled: null,
      id: 3,
      name: "Others",
    },
  ],
};

export const DOCUMENT_TYPE = {
  description: "Document Type",
  names: [
    {
      disabled: null,
      id: 1,
      name: "Sharepoint List",
    },
    {
      disabled: null,
      id: 2,
      name: "Databricks Table",
    },
    {
      disabled: null,
      id: 3,
      name: "Excel File",
    },
    {
      disabled: null,
      id: 4,
      name: "Salesforce",
    },
    {
      disabled: null,
      id: 5,
      name: "Others",
    },
  ],
};

export const errorMessages = [
  {
    statusCode: "nam-403",
    statusText: "Timeout",
    message: "You don't have access to this page.",
  },
  {
    statusCode: "nam-404",
    statusText: "Timeout",
    message: "Page not found! Please retry after sometime.",
  },
  {
    statusCode: "nam-408",
    statusText: "Timeout",
    message: "Too many heavy queries! Please retry after sometime.",
  },
  {
    statusCode: "nam-409",
    statusText: "Timeout",
    message: "the request could not be processed! Please retry after sometime.",
  },
  {
    statusCode: "nam-413",
    statusText: "Timeout",
    message: "Too many heavy queries! Please retry after sometime.",
  },
  {
    statusCode: "nam-415",
    statusText: "Timeout",
    message: "Too many heavy queries! Please retry after sometime.",
  },
  {
    statusCode: "nam-500",
    statusText: "InternalServerError",
    message: "Internal server error! Please retry after sometime.",
  },
];

export const RLS_MESSAGES = {
  confirmationMessage: "Does this report support Row Level Security(RLS)?  ",
  azureADConsentMessage:
    "I have added the above Azure AD Group to my Power BI Report",
  fullAccessMessage:
    "By adding this Azure AD Group to your PowerBI Report, you will be able to manage Full Access from the DART Portal. If this is not done, DART Portal will not be able to support Centralised Access.",
  rlsMessage:
    "We are gathering this information so that we can collect appropriate access requests from users when they request for permissions from the DART Portal. We advise you to fill this up so that we can make the user journey as easy as possible.",
  rlsDocumentMessage:
    "We are gathering this information so that we can create an easy link for you from the DART Portal to access your RLS Document. We are not authorised to make any changes to this document.",
};

export const filtersHeader = {
  app_types: "App Type",
  category: "Category",
  functions: "Functions",
  owners: "Owners",
  product_lines: "Product Lines",
  regions: "Regions",
  tables: "Tables",
  tags: "Tags",
};

export const brainApproverTabConstants = {
  my_task: "my_task",
  unassigned: "unassigned",
  all_submissions: "all-submissions",
};
export const tabViewInitial = {
  discover: "app_product_name",
  saved: "date_category",
};

export const GA_ID = {
  DEV: "G-81EKBQ88DM",
  PROD: "G-F78WVJHE64",
};
export const GTM_ID = {
  DEV: "GTM-KF96TTJ5",
  PROD: "GTM-PWJDK5PG",
};

export const harborApproverTabConstants = {
  my_task: "my_task",
  unassigned: "unassigned",
  all_submissions: "all-submissions",
};

export default APP_CONSTANTS;
